// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dwhGsGc8rAAtikB5AzXT {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.dwhGsGc8rAAtikB5AzXT .gw4Tvx0DA9pd791BTyy0 {
  display: flex;
  justify-content: center;
  gap: 4vmin;
  padding: 0;
  list-style: none;
  flex-flow: row wrap;
  width: 95vw;
}`, "",{"version":3,"sources":["webpack://./src/components/GameList/GameList.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;AACI;EACI,aAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AACR","sourcesContent":[".gameList {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    .list {\n        display: flex;\n        justify-content: center;\n        gap: 4vmin;\n        padding: 0;\n        list-style: none;\n        flex-flow: row wrap;\n        width: 95vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameList": `dwhGsGc8rAAtikB5AzXT`,
	"list": `gw4Tvx0DA9pd791BTyy0`
};
export default ___CSS_LOADER_EXPORT___;
